import StringMixin from "@/components/mixins/StringMixin";

export default {
    legend: {
        position: 'bottom'
    },
    dataLabels: {
        enabled: false,
    },
    tooltip: {
        enabled: false,
    },
    responsive: [
        {
            breakpoint: 1200,
            options: {
                chart: {
                    height: '100%',
                },
                plotOptions: {
                    pie: {
                        donut: {
                            labels: {
                                show: false,
                            },
                        },
                    },
                },
            },
        },
        {
            breakpoint: 1280,
            options: {
                chart: {
                    height: '100%',
                },
                plotOptions: {
                    pie: {
                        donut: {
                            labels: {
                                name: {
                                    fontSize: '12px',
                                },
                                value: {
                                    offsetY: -5,
                                },
                            },
                        },
                    },
                },
            },
        },
    ],
    plotOptions: {
        pie: {
            donut: {
                labels: {
                    show: true,
                    name: {
                        fontSize: '1vw',
                    },
                    value: {
                        formatter: (value) => {
                            const number = Number(value).toFixed(0)
                            return `€ ${StringMixin.methods.getEuropeanNumberFormat(number)}`
                        },
                        fontSize: 'calc(100% + 0.3vw)',
                        offsetY: 0,
                    }
                },
            },
        },
    },
    labels: [],
    colors: [],
};
